import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "w-30px me-3",
  src: "/media/svg/files/pdf.svg"
}, null, -1)
const _hoisted_3 = { class: "ms-1 fw-bold" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-gray-400" }
const _hoisted_6 = {
  key: 1,
  class: "row g-6 g-xl-9 mb-6 mb-xl-9"
}
const _hoisted_7 = { class: "card h-100 border" }
const _hoisted_8 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-60px mb-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/svg/files/pdf.svg",
    alt: ""
  })
], -1)
const _hoisted_11 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_12 = { class: "fs-7 fw-semobold text-gray-400 mt-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewFile = _resolveComponent("ViewFile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.view=='rectangle')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, y) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'cdf-' + y,
              class: "d-flex flex-aligns-center px-4 py-2 me-5 bg-white border border-secondary rounded"
            }, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.openViewFile(file.archive)),
                  target: "_blank",
                  class: "fs-6 fw-bolder"
                }, _toDisplayString(file.name), 9, _hoisted_4),
                _createElementVNode("div", _hoisted_5, _toDisplayString(file.created_at), 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.view=='square')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'cdf-' + index,
              class: "col-12 col-sm-12 col-md-4"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.openViewFile(file.archive)),
                    target: "_blank",
                    class: "text-gray-800 text-hover-primary d-flex flex-column"
                  }, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, _toDisplayString(file.name), 1)
                  ], 8, _hoisted_9),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(file.created_at), 1)
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ViewFile)
  ], 64))
}